const defer = () => {
  let state = false; // Resolved or not
  let callbacksQueue = [];
  const resolve = val => {
    if (state) {
      return;
    }
    state = true;
    for (let i = 0, len = callbacksQueue.length; i < len; i++) {
      callbacksQueue[i](val);
    }
    callbacksQueue = [];
  };

  const then = cb => {
    if (!state) {
      callbacksQueue.push(cb);
      return;
    }
    cb();
  };

  const deferred = {
    resolved() {
      return state;
    },
    resolve,
    promise: {
      then
    }
  };
  return deferred;
};

export default defer;
